export default "__VITE_ASSET__El9lEsBQ__"